import { DependencyToken, ProviderDefinition } from '@cp/shared/di';
import { detectIsBrowser } from '@cp/utils/browser';
import { Container } from '../../ioc';

type TokenPrimitive = string | symbol | number;
const createObjectStorage = (): Map<TokenPrimitive, unknown> => {
  return new Map();
};
const createBrowserStorage = (): Map<TokenPrimitive, unknown> => {
  if (!window['ioc']) {
    window['ioc'] = createObjectStorage();
  }
  return window['ioc'];
};
const storage = detectIsBrowser() ? createBrowserStorage() : createObjectStorage();
const factoryStorage = new Map<TokenPrimitive, () => unknown>();

export const container: Container = {
  get: <T>(token: DependencyToken<T>) => {
    if (storage.has(token.id)) {
      return storage.get(token.id) as T;
    } else if (factoryStorage.has(token.id)) {
      const factory = factoryStorage.get(token.id) as () => T;
      return factory();
    }
    throw new Error(`${String(token.id)} not found in container`);
  },
  bind: <T>(provider: ProviderDefinition<T>) => {
     
    if ('useValue' in provider) {
      storage.set(provider.provide.id, provider.useValue);
    } else if ('useFactory' in provider) {
      factoryStorage.set(provider.provide.id, provider.useFactory);
    } else {
      throw new Error('This binding type not supported.', { cause: provider });
    }
  },
  use(module) {
    throw new Error('This container not support importing modules');
  },
};
